// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Next__Image = require("../../reason/next/Next__Image.bs.js");
var ReasonPromise = require("../../reason/ReasonPromise.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SelectProfilePhotoButton = require("../common/ProfilePicture/SelectProfilePhotoButton.bs.js");
var TeamMarketingProfileLogoForm_RemoveMutation_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_RemoveMutation_graphql.bs.js");
var TeamMarketingProfileLogoForm_UpdateMutation_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_UpdateMutation_graphql.bs.js");
var TeamMarketingProfileLogoForm_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.bs.js");

var convertFragment = TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertVariables;

var convertResponse = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileLogoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileLogoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateMutation_imageContentType_decode = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Utils.imageContentType_decode;

var UpdateMutation_imageContentType_fromString = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Utils.imageContentType_fromString;

var UpdateMutation = {
  imageContentType_decode: UpdateMutation_imageContentType_decode,
  imageContentType_fromString: UpdateMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

var convertVariables$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertVariables;

var convertResponse$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, TeamMarketingProfileLogoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, TeamMarketingProfileLogoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

var acceptedImageTypes = [
  "JPEG",
  "GIF",
  "PNG",
  "WEBP"
];

function parseContentType(contentType) {
  switch (contentType) {
    case "image/gif" :
        return {
                TAG: "Ok",
                _0: "GIF"
              };
    case "image/jpeg" :
        return {
                TAG: "Ok",
                _0: "JPEG"
              };
    case "image/png" :
        return {
                TAG: "Ok",
                _0: "PNG"
              };
    case "image/webp" :
        return {
                TAG: "Ok",
                _0: "WEBP"
              };
    default:
      return {
              TAG: "Error",
              _0: {
                NAME: "UnsupportedMimeType",
                VAL: contentType
              }
            };
  }
}

function TeamMarketingProfileLogoForm$WithoutErrorBoundary(props) {
  var marketingProfile = use(props.teamMarketingProfile);
  var match = React.useState(function () {
        return "InitialState";
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = use$1();
  var runUpdateMutation = match$1[0];
  var match$2 = use$2();
  var runRemoveMutation = match$2[0];
  var upload = AvatarUploadProvider.useUpload();
  var onSelectImage = function (file) {
    setState(function (param) {
          return "Saving";
        });
    var dataUrl = URL.createObjectURL(file);
    ReasonPromise.get(upload(dataUrl), (function (upload) {
            if (upload.TAG === "Ok") {
              var match = upload._0;
              var contentType = parseContentType(match.contentType);
              if (contentType.TAG === "Ok") {
                var contentType$1 = contentType._0;
                runUpdateMutation({
                      input: {
                        logo: {
                          contentType: contentType$1 === "PNG" ? "PNG" : (
                              contentType$1 === "JPEG" ? "JPEG" : (
                                  contentType$1 === "WEBP" ? "WEBP" : "GIF"
                                )
                            ),
                          fileName: match.fileName,
                          id: match.id,
                          key: match.key
                        }
                      }
                    }, undefined, undefined, undefined, (function (_response, errors) {
                        if (errors !== undefined) {
                          return setState(function (param) {
                                      return {
                                              TAG: "Error",
                                              _0: "UploadError"
                                            };
                                    });
                        } else {
                          return setState(function (param) {
                                      return "InitialState";
                                    });
                        }
                      }), (function (_error) {
                        setState(function (param) {
                              return {
                                      TAG: "Error",
                                      _0: "UploadError"
                                    };
                            });
                      }), undefined);
              } else {
                var s = contentType._0.VAL;
                setState(function (param) {
                      return {
                              TAG: "Error",
                              _0: {
                                TAG: "UnsupportedMimeType",
                                _0: s
                              }
                            };
                    });
              }
            } else {
              setState(function (param) {
                    return {
                            TAG: "Error",
                            _0: "UploadError"
                          };
                  });
            }
            URL.revokeObjectURL(dataUrl);
          }));
  };
  var onRemoveLogo = function () {
    setState(function (param) {
          return "Saving";
        });
    runRemoveMutation(undefined, undefined, undefined, undefined, (function (_response, errors) {
            if (errors !== undefined) {
              return setState(function (param) {
                          return {
                                  TAG: "Error",
                                  _0: "RemovePhotoError"
                                };
                        });
            } else {
              return setState(function (param) {
                          return "InitialState";
                        });
            }
          }), (function (_error) {
            setState(function (param) {
                  return {
                          TAG: "Error",
                          _0: "RemovePhotoError"
                        };
                });
          }), undefined);
  };
  var tmp;
  var exit = 0;
  if (typeof state !== "object" && state !== "InitialState") {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var tmp$1;
    if (typeof state !== "object") {
      tmp$1 = null;
    } else {
      var tmp$2 = state._0;
      tmp$1 = typeof tmp$2 !== "object" ? (
          tmp$2 === "UploadError" ? JsxRuntime.jsx(Alert.$$Error.make, {
                  title: "There was an error updating your image. Please try again."
                }) : JsxRuntime.jsx(Alert.$$Error.make, {
                  title: "There was an error removing your logo. Please try again."
                })
        ) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "The selected image format is not supported."
            });
    }
    var logo = marketingProfile.logo;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            tmp$1,
            logo !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Next__Image.make, {
                                  src: logo.url,
                                  width: 96,
                                  height: 96,
                                  unoptimized: true,
                                  alt: "Your current logo",
                                  className: "w-24 h-24 rounded-md object-contain"
                                }),
                            className: "border border-zinc-200 p-1 rounded-md"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                                    onSelectProfilePhoto: onSelectImage,
                                    acceptedImageTypes: acceptedImageTypes,
                                    children: "Change logo"
                                  }),
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        onRemoveLogo();
                                      }),
                                    size: "small",
                                    children: "Remove logo"
                                  })
                            ],
                            className: "flex flex-col gap-4 items-start md:items-center lg:items-start"
                          })
                    ],
                    className: "flex gap-4 md:items-center lg:items-start md:flex-col lg:flex-row"
                  }) : JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                          onSelectProfilePhoto: onSelectImage,
                          acceptedImageTypes: acceptedImageTypes,
                          children: "Upload"
                        })
                  })
          ],
          className: "flex flex-col gap-4"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Logo"
                                  }),
                              JsxRuntime.jsx("small", {
                                    children: "Upload a logo to display at the top of your marketing profile next to your team name.\n",
                                    className: "text-base text-zinc-500"
                                  })
                            ]
                          }),
                      className: "pt-2 col-span-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: "mt-2 sm:col-span-3 sm:mt-0 "
                    })
              ],
              className: "sm:grid sm:grid-cols-5 sm:items-start gap-16 py-6 space-y-6"
            });
}

var WithoutErrorBoundary = {
  make: TeamMarketingProfileLogoForm$WithoutErrorBoundary
};

function TeamMarketingProfileLogoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "Team logo",
              children: JsxRuntime.jsx(TeamMarketingProfileLogoForm$WithoutErrorBoundary, {
                    teamMarketingProfile: props.teamMarketingProfile
                  })
            });
}

var make = TeamMarketingProfileLogoForm;

exports.Fragment = Fragment;
exports.UpdateMutation = UpdateMutation;
exports.RemoveMutation = RemoveMutation;
exports.acceptedImageTypes = acceptedImageTypes;
exports.parseContentType = parseContentType;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
